<template>
  <router-link :to="{ name: 'profile_access' }">
    <template v-if="service.sharedaccess">
      Enabled
    </template>
    <template v-else>
      Shared With Me
    </template>
  </router-link>
</template>

<script>
export default {
  name: 'SharedServiceTag',
  props: {
    service: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>
